import { Component, Inject, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CONTEXT_SERVICE, ContextService } from 'src/app/services/context/context.model';
import { NavControllerService } from 'src/app/services/nav-controller.service';

@Component({
  selector: 'app-messenger-page',
  templateUrl: './messenger.page.html',
  styleUrls: ['./messenger.page.scss'],
})
export class MessengerPage implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    @Inject(CONTEXT_SERVICE) private contextService: ContextService,
    private navController: NavControllerService,
    private zone: NgZone,
  ) { }

  ngOnInit(): void {

    this.route.params.subscribe(data => {

      this.zone.run(() => {
        let url;

        if (data?.chatId) {
          url = `/${this.contextService.currentContext.key}/contacts?tab=my-chats&chatId=${data?.chatId}`;
        } else {
          url = `/${this.contextService.currentContext.key}/contacts?tab=my-chats`;
        }

        if (url) {
          this.navController.navigateForward(`${this.contextService.currentContext.key}/contacts`)?.finally(() => {
            setTimeout(() => {
              this.router.navigateByUrl(url, { replaceUrl: true });
            }, 100);
          });
        }
      });
    });
  }
}
